import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Container, Grid, Paper, Box } from "@mui/material";
import Layout from "../Layout";
import { fetchRequest } from "../../store/processor/actions";
import { ApplicationState } from "../../store";
import ProcessorTable from "./processorTable/ProcessorTable";
import PageHeading from "../../common/pageHeading/PageHeading";
import useSession from "../../effects/useSession";
import pageStyles from "../pageStyles";
import ProgressIndicator from "../../common/progressIndicator/ProgressIndicator";

export default function Processor() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = pageStyles();
  const session = useSession();

  useEffect(() => {
    dispatch(fetchRequest(null));
  }, []);

  const { loading, data } = useSelector(
    (state: ApplicationState) => state.processor
  );
  const processor = data?.data ?? [];

  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading
                  entity="Processor"
                  heading="Processors"
                  primaryButtonText="Add new processor"
                  primaryButtonClickHandler={() =>
                    history.push("/processor/new")
                  }
                />
              </Paper>
              <Box my={2}>
                {loading ? (
                  <ProgressIndicator />
                ) : (
                  <ProcessorTable processorData={processor} />
                )}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}
